<template>
  <div class="mt-4">
    <a href="javascript:void(0)" class="text-muted" @click="show">{{ $t("esqueciMinhaSenha") }}</a>
    <BaseFormModal ref="base" name="lostPassModal" :centered="true" @show="onShow">
      <template #title>
        {{ $t("recuperarSenha") }}
      </template>
      <template #body>
        <input
          ref="mail" v-model="email" type="email" class="w-100 form-control" :placeholder="$t('email')" required
        >
      </template>
      <template #footer>
        <button type="button" class="btn btn-secondary" @click="$refs.base.hide()">
          <i class="bi bi-x" /> {{ $t("cancelar") }}
        </button>
        <LoadingButton class="btn-primary mw-120" :loading="loading" @click="submit">
          <i class="bi bi-envelope" /> {{ $t("recuperar") }}
        </LoadingButton>
      </template>
    </BaseFormModal>
  </div>
</template>

<script>
import BaseFormModal from '@/modules/core/components/BaseFormModal.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { rescue } from '../service';
import { useToast } from 'vue-toastification';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';

export default {
  components: { BaseFormModal, LoadingButton },
  data: () => ({ loading: false, email: '' }),
  methods: {
    onShow() { this.email = ''; },
    show() {
      this.$refs.base.show();
      setTimeout(() => this.$refs.mail.focus(), 200);
    },
    submit() { !this.loading && this.$refs.base.validate() && this.rescue(); },
    async rescue() {
      this.loading = true;
      try {
        await rescue({ email: this.email });
        useToast().success(ref(computed((_) => i18n.global.t('umaNovaSenhaFoiEnviadaParaOSeuEmail'))));
        this.$refs.base.hide();
      } catch (e) {
        useToast().error(ref(computed((_) => i18n.global.t('erroDeConexao'))));
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.mw-120 {
  min-width: 120px;
}
</style>
